import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';

import ProtectedRoute from "./components/ProtectedRoute";
import PinEntryGuard from "./components/PinEntryGuard";

import MainDashboard from "./pages/homePage/dashboard";
import LoginPage from "./pages/clockInAndOut/index"
import ClockInPhoto from "./pages/clockInPhoto/index";
import EmployeeClockedIn from "./pages/employeeClockedIn/index"
import ClockOutPin from "./pages/clockOutPin/index";
import ClockOutPhoto from "./pages/clockOutPhoto/index";


// import Dashboard from "./pages/adminPages/Dashboard";
// import ResourceDisplay from "./pages/resourcePage";
// import ResourceResult from "./pages/resourcePage/resourceResults";


import { CssBaseline, ThemeProvider } from "@mui/material";
import { useMode } from "./theme/theme";
import "./App.css";


function App() {
  const [cobotTheme] = useMode();

  return (
      <ThemeProvider theme={cobotTheme}>
        <CssBaseline />
        <div className="app">
          <main className="content">
            <Toaster 
              toastOptions={{
                style: {
                  maxWidth: '500px'
                },
              }}
            />
            <Routes>
              <Route path="/" element={<MainDashboard />} />
              {/* <Route path="/ResourceDisplay" element={<ResourceDisplay />} /> */}
              {/* <Route path="/ResourceResult/:resourceCategory/:resourceId" element={<ResourceResult />} /> */}
              <Route element={<PinEntryGuard />}>
                <Route path="/LoginPage/:id" element={<LoginPage />} />
              </Route>
              <Route element={<ProtectedRoute />}>
              <Route path="/ClockInPhoto/:id" element={<ClockInPhoto />} />
                <Route path="/EmployeeClockedIn/:id" element={<EmployeeClockedIn />} />
                <Route path="/ClockOutPin/:id" element={<ClockOutPin />} />
                <Route path="/ClockOutPhoto/:id" element={<ClockOutPhoto />} />
              </Route>
            </Routes>
          </main>
        </div>
      </ThemeProvider>
  );
}

export default App;